
var OtherwiseCtrl = function ($scope, $state, previousState, SettingsConstants, $log) {
    $log.info('Unrecognized URL detected. Going to the previous state or, if it absent, going to the default state');
    // if we have stored name of previous state
    // head user back, if not - head user to
    // default application state
    if (previousState.name) {
        $state.go(previousState.name, previousState.params);
    } else {
        $state.go(SettingsConstants.APP_DEFAULT_STATE);
    }
};
OtherwiseCtrl.$inject = ['$scope', '$state', 'previousState', 'SettingsConstants', '$log'];

module.exports = OtherwiseCtrl;
